import api from "@/plugins/api";

export const fetchMyCalendarUpcomingEvents = async ({ commit }) => {
  const response = await api({
    method: "GET",
    endpoint: "mycalendar/upcoming"
  });

  const { data } = response;

  commit("myCalendarUpcomingEvents", data);
};
